import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/portal/dashboard');
    } catch (err) {
      setError(err.message || 'Failed to sign in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 border border-slate-200">
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-navy-900 rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg border border-navy-800">
            <span className="text-gold-500 font-serif font-bold text-3xl">K</span>
          </div>
          <h1 className="text-2xl font-serif font-bold text-navy-900 mb-2">The Kajidori Portal</h1>
          <p className="text-slate-500 text-sm">Resilience. Clarity. Excellence.</p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 p-4 rounded-lg text-sm mb-6 flex items-center gap-2 border border-red-100">
            <SafeIcon name="AlertTriangle" className="w-5 h-5" />
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-bold text-navy-900 uppercase tracking-wider">Email Address</label>
            <input 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-lg border border-slate-200 outline-none focus:border-navy-900 focus:ring-1 focus:ring-navy-900"
              placeholder="name@organisation.com"
            />
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <label className="text-sm font-bold text-navy-900 uppercase tracking-wider">Password</label>
              <Link to="/portal/forgot-password" size="sm" className="text-xs text-navy-600 hover:text-navy-900 font-semibold">Forgot password?</Link>
            </div>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-lg border border-slate-200 outline-none focus:border-navy-900 focus:ring-1 focus:ring-navy-900"
              placeholder="••••••••"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-navy-900 text-white py-4 rounded-xl font-bold text-lg hover:bg-navy-800 transition-all shadow-lg active:scale-[0.98] disabled:opacity-50"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>

        <div className="mt-8 pt-8 border-t border-slate-100 text-center space-y-4">
          <p className="text-sm text-slate-500">
            Don't have an account? <Link to="/portal/register" className="text-navy-900 font-bold hover:underline">Register here</Link>
          </p>
          <Link to="/" className="text-sm text-slate-400 hover:text-navy-900 flex items-center justify-center gap-2">
            <SafeIcon name="ArrowLeft" className="w-4 h-4" /> Back to Main Site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;